export default {
  nav: {
    onlineSms: '在线短信',
    rentNumber: '软件开发',
    esim: '彩票开奖',
    apiConnection: 'API连接',
    agent: '在线客服',
    blog: '项目分享',
    help: '帮助',
    register: '注册',
    login: '登录'
  },
  header: {
    memberCenter: '会员中心',
    logout: '退出登录',
    logoutSuccess: '已退出登录'
  },
  common: {
    user: '用户',
    chinese: '中文',
    loading: '加载中...',
    noData: '暂无数据',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    submit: '提交',
    search: '搜索',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '提示',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    networkError: '网络错误，请稍后重试',
    payWith: '支付方式',
    unit: '个',
    yes: '是',
    no: '否',
    all: '全部',
    more: '更多',
    next: '下一步',
    prev: '上一步'
  },
  home: {
    title: '接码平台',
    subtitle: '在社交网络、网上商城、交易所和在线服务中注册不会收到垃圾邮件或泄露个人数据。',
    btnGetNumber: '租用号码',
    btnRent: '短租',
    phoneCount: '1000+',
    sectionTitle: 'SMS-MAN — 租用电话号码来接收短信',
    sectionDesc: '在SMS-MAN的帮助下你可以租用一个虚拟号码来接收来自200+个国家的短信。可租周期：24小时、一周或一个月。你可以租用一个号码，在所选的整段租用时间内能无限次接收短信。',
    sectionDesc2: '当你需要用一个指定手机号注册很多个在线应用的时候非常方便。如果号码不合适（如果你没有接收到任何短信），你可以在20分钟内免费取消！',
    howItWorks: '看看这是如何操作的',
    stepsTitle: '3步即刻在线租用虚拟号码',
    step1Title: '选择你的国家',
    step2Title: '设置租赁期限',
    step3Title: '租用一个号码',
    step1Desc: '印度、墨西哥、以色列',
    step2Desc: '小时、天、周、月',
    step3Desc: '租期不存在',
    whyChoose: '为什么选择SMS-MAN',
    feature1Title: '你可以购买一次性的电话号码，或者租最长长达一个月的号码',
    feature2Title: '用于接收短信的一次性号码',
    feature2Desc: '下单时选择某项服务或所有服务通过虚拟号码接收短信。从任何网站或应用程序接收一次性短信验证码。',
    feature3Title: '租用号码',
    feature3Desc: '租用电话号码，从任何网站或应用程序接收无限数量的短信。',
    usageLimit: '使用限制',
    usageLimitDesc: '最多20分钟',
    usageLimitDesc2: '最长可达30天',
    youCanReceive: '你可以接收短信',
    youCanReceiveDesc: '从你在订购时选择的一个网站/应用程序中接收 无限制',
    youCanReceiveDesc2: '所有可订的服务',
    serviceCount: '200+',
    serviceCount2: '16',
    countryCount: '1000+',
    countryCount2: '所有可订的服务',
    btnRentNow: '短租',
    btnRentNumber: '租用号码',
    aboutText: '"SMS-Man" 让有机会创建一个虚拟号码来接收短信。租用的号码几乎所有需要手机号码的平台上注册。',
    aboutText2: '许多网站都要求通过SMS短信验证的手机号码。这些服务通常无法在海外手机号码下使用。另外为注册目的购买SIM卡既麻烦又昂贵。只需要支付一次约0.5-1美元，约折合人民币，你的许多网站注册以及业务联系。',
    aboutText3: 'SMS-MAN提供了超过200多个国家/地区的服务。你可以租用虚拟号码，从任何网站或应用程序接收短信。',
    aboutText4: '在"SMS-Man" 租用号码有很多好处，例如：',
    aboutText5: '一个虚拟号码可以在200多个网站和应用程序中注册使用。',
    aboutText6: '你不必担心泄露自己的个人电话号码和多个垃圾短信了。',
    aboutText7: '在一个平台上管理多个不同国家的号码和接收短信。',
    aboutText8: '您不需要专业的技能来使用号码，而且价格很便宜。',
    aboutText9: '您可以随时随地在线租用一个电话号码！',
    registerTitle: '注册',
    registerDesc: '您不需要输入个人信息，只需3个步骤',
    regStep1: '在网站上输入您的电子邮件',
    regStep1Desc: '输入您的电子邮件地址并创建密码。',
    regStep2: '在您的邮箱中确认您的电子邮件',
    regStep2Desc: '我们已向您输入的电子邮件发送了一封确认邮件。请打开邮件，点击确认链接。',
    regStep3: '恭喜您！您已注册成功',
    regStep3Desc: '您现在可以登录并使用SMS-MAN的所有服务。',
    onlineServiceTitle: '为您提供方便的在线短信接收服务',
    joinTelegram: '加入我们在线聊天',
    joinTelegramDesc: '加入我们的Telegram群组获取最新资讯',
    telegramBot: 'Telegram bot',
    telegramBotDesc: '使用Telegram Bot接收短信',
    userGroup: '用户交流群',
    userGroupDesc: '加入用户交流群获取帮助',
    desktopApp: '电脑端应用程序',
    desktopAppDesc: '下载桌面应用程序',
    btnJoin: '加入',
    btnConnect: '连接',
    btnDownload: '下载',
    professionalTitle: '专业人士的解决方案',
    professionalDesc: 'SMS-MAN不仅为普通用户提供便捷工具，而且还为需要大量注册账户和访问限制资源的专业人士提供便捷工具。',
    apiConnect: '通过API连接',
    apiConnectDesc: '批量接收发送短信，实现工作自动化',
    readMore: '阅读更多内容',
    faqTitle: '常见问题',
    faq1: '短信平台服务是什么？如何运作？',
    faq2: '什么是SMS-MAN？',
    faq3: '我需要一次性SIM卡来接收短信吗？',
    faq4: '使用SMS-MAN，私人信息是否安全？',
    faq5: '如何确认短信接收成功？',
    faq6: '短信平台，真的安全吗？',
    faq7: '为什么选择SMS-Man来接收短信？',
    footer: {
      smsPlatform: '接码平台',
      rentNumber: '租用号码',
      apiConnection: 'API连接',
      referral: '返利推广',
      partnership: '合作',
      partners: '合作伙伴',
      blog: '项目分享',
      help: '帮助',
      privacyPolicy: '隐私政策',
      termsOfUse: '使用条款',
      paymentRefund: '付款与退款',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  login: {
    title: '登录',
    email: '邮箱',
    password: '密码',
    emailPlaceholder: '输入邮箱',
    passwordPlaceholder: '输入密码',
    forgotPassword: '忘记密码？',
    noAccount: '还没有账户吗？',
    register: '注册',
    socialLogin: '或用你的社交平台登录',
    btnLogin: '登录',
    captchaSuccess: '成功！',
    loginFailed: '登录失败'
  },
  register: {
      title: '注册',
      email: '输入邮箱',
      codePlaceholder: '请输入验证码',
      sendCode: '获取验证码',
      sending: '发送中...',
      codeSent: '验证码已发送，请查看邮箱',
      password: '创建密码',
      confirmPassword: '确认密码',
      agreeTerms: '注册该服务即表示您同意',
      terms: '使用条款',
      hasAccount: '已经拥有账号了？',
      login: '登录',
      socialLogin: '或用你的社交平台登录',
      btnRegister: '注册',
      registering: '注册中...',
      captchaSuccess: '成功！',
      passwordMismatch: '两次密码输入不一致',
      registerFailed: '注册失败',
      codeExpired: '验证码已过期，请重新获取',
      codeError: '验证码错误'
    },
  member: {
    sidebar: {
      receiveSms: '接收短信',
      premiumSms: '高级短信',
      rentNumber: '租用号码',
      esim: 'eSIM',
      proxyMan: 'Proxy Man',
      recharge: '充值余额',
      loyalty: '忠诚度计划',
      earn: '赚取',
      partnership: '合作',
      api: 'API',
      instructions: '说明',
      feedback: '反馈',
      help: '帮助',
      chatGroup: '在线客服',
      chatManage: '聊天管理',
      receptionRecords: '接待记录',
      chatPlan: '套餐管理',
	  agentManage: '坐席管理',
	  chatSettings: '客服设置',
      lotteryGroup: '彩票管理',
      lotteryBets: '投注记录'
    },
    header: {
      desktopClient: '电脑客户端',
      desktopClientDesc: '直接在电脑上接收短信',
      telegramBot: 'Telegram 机器人',
      telegramBotDesc: '直接在 Telegram 上接收短信',
      try: '试用',
      connect: '连接',
      balance: '总余额',
      recharge: '充值',
      language: '语言'
    },
    avatarMenu: {
      settings: '会员设置',
      profile: '查看信息',
      logout: '退出登录'
    },
    receiveSms: {
      title: '接收短信',
      selectService: '选择一个服务',
      searchService: '根据服务搜索',
      selectCountry: '选择你的国家',
      searchCountry: '按国家搜索',
      sort: '排序',
      buySms: '购买短信',
      doubleSms: '双倍短信',
      btnBuySms: '购买短信'
    },
    premiumSms: {
      title: '高级短信',
      selectService: '选择一个服务',
      searchService: '根据服务搜索',
      selectCountry: '选择你的国家',
      searchCountry: '按国家搜索',
      sort: '排序',
      buySms: '购买短信',
      doubleSms: '双倍短信',
      btnBuySms: '购买短信'
    },
    rentNumber: {
      title: '租用号码',
      subtitle: '仅可用于接收短信',
      wholeNumber: '整号租用',
      byService: '按服务租用',
      selectCountry: '1. 选择国家',
      search: '搜索',
      setDuration: '2. 设置租用时长',
      hour: '小时',
      day: '天',
      week: '周',
      month: '月',
      rentNumber: '3. 租用号码',
      cost: '费用为',
      btnRent: '租用',
      rentDesc: '您支付的是号码及其租用期。在所选期限内，您可以接收不限数量的短信。购买后不支持取消、退款或提前终止租用。',
      premiumTitle: '高级 号码',
      premiumDesc: '访问高质量号码，获得更高的送达率和更强的可靠性，用于短信验证',
      btnPremium: '开通 Premium'
    },
    esim: {
      title: 'eSIM',
      selectCountry: '1. 选择国家 / 地区',
      searchCountry: '搜索国家或地区',
      all: '全部',
      mixed: '混合',
      showAll: '显示全部',
      selectPlan: '2. 选择套餐',
      esimInfo: 'eSIM 在付款后立即激活。安装二维码将在您的账户中提供。',
      phoneSupport: '您的手机支持 eSIM 吗？',
      phoneSupportDesc: '拨 *#06#，如果显示 EID，说明设备支持 eSIM。',
      howToConfig: '如何通过 eSIM 配置移动数据',
      selectType: '3. 选择 eSIM 类型',
      allType: '全部',
      dataOnly: '纯流量',
      dataAndCall: '流量 + 通话',
      btnRecharge: '充值余额'
    },
    recharge: {
      title: '充值余额',
      payMethod: '支付方式',
      usdtDesc: '通过 USDT TRC-20 转账充值，后台确认后到账',
      onlyUsdt: '仅支持 USDT',
      fillAmount: '充值金额',
      otherAmount: '自定义金额',
      btnPay: '立即充值',
      submitting: '提交中...',
      payDesc: '创建订单后将显示 USDT 收款地址和二维码',
      invalidAmount: '请输入有效充值金额（最低 $1）',
      rechargeFailed: '充值失败',
      rechargeFailedRetry: '充值失败，请重试',
      historyTitle: '充值记录',
      thOrderNo: '订单号',
      thAmount: '金额',
      thStatus: '状态',
      thTime: '时间',
      statusPending: '待确认',
      statusPaid: '已到账',
      statusCancelled: '已取消',
      scanToPay: '扫码支付',
      payAmount: '支付金额',
      usdtAddress: 'USDT TRC-20 收款地址',
      copy: '复制',
      copied: '已复制',
      orderNo: '订单号',
      waitingConfirm: '等待后台确认到账，支付成功后将自动刷新',
      paySuccess: '充值到账',
      paySuccessDesc: '您的充值已成功到账'
    },
    feedback: {
      title: '联系我们',
      name: '您的姓名',
      email: '邮箱',
      question: '您的问题',
      btnSend: '发送',
      captchaSuccess: '成功！',
      support247: '客服 7×24 小时在线',
      responseTime: '平均响应时间约 15 分钟',
      weekendWork: '周末客服照常工作',
      chatSupport: '客服聊天',
      youtube: '我们的 YouTube'
    },
    partnership: {
      title: '通过SIM卡在可靠的服务上赚钱',
      desc1: '如果你有可以用来接收短信的电话号码（sim卡）--这个页面正是你需要的。',
      desc2: '在SMS-Man上使用SIM卡开始赚钱!',
      whatTogether: '我们可以一起做什么？',
      whatTogetherDesc: 'SMS-Man 是一个提供在线短信接收的国际平台。我们目前有20万活跃用户，每天有超过1亿的短信请求。',
      whatTogetherDesc2: '而且这还不是最多的：我们客户的要求正在迅速增长。这就是为什么我们在寻找你的原因。',
      howContact: '如何联系SMS-Man?',
      restApi: 'REST API',
      restApiDesc: '你向我们提供API文件和直接付款的账户。我们将其纳入系统中',
      gsmGoip: 'GSM/GoIP',
      gsmGoipDesc1: '你有GSM/GoIP设备',
      gsmGoipDesc2: '我们使用特殊的软件将您连接到我们的系统中',
      gsmGoipDesc3: '你将能够在一个专门的仪表板上跟踪统计数据',
      gsmGoipDesc4: '收入取决于SIM卡的国家',
      apiLink: 'API链接',
      apiLinkDesc1: '例如，你有这样格式的号码：',
      apiLinkDesc2: '我们根据条款来购买号码'
    },
    instructions: {
      title: '通过SMS-MAN注册Facebook',
      step1: '步骤1. 获得一个号码。',
      step1Desc: '为此，您使用一次性',
      receiveSms: '接收短信',
      or: '或',
      rentNumber: '租用号码',
      step2: '第2步：复制你收到的号码。',
      step2Desc: '通过点击旁边的图标或选择数字,按Ctrl+C来复制该号码.',
      step3: '第3步。填写facebook注册信息。',
      step3Desc: '前往facebook.com,点击"创建新账户"。'
    },
    loyalty: {
      title: '忠诚度计划'
    },
    earn: {
      title: '赚取'
    },
    api: {
      title: 'API 文档'
    },
    help: {
      title: '帮助中心'
    },
    lotteryBets: {
      title: '投注记录',
      allTypes: '全部彩种',
      allResults: '全部结果',
      win: '中奖',
      lose: '未中奖',
      pending: '待开奖',
      searchPeriod: '搜索期号...',
      totalBets: '总投注',
      totalWin: '中奖',
      totalLose: '未中奖',
      totalPending: '待开奖',
      totalProfit: '总盈亏',
      period: '期号',
      lotteryType: '彩种',
      playType: '玩法',
      betContent: '投注内容',
      betAmount: '投注金额',
      odds: '赔率',
      drawNumbers: '开奖号码',
      result: '结果',
      profit: '盈亏',
      time: '时间',
      totalRecords: '共 {0} 条记录',
      prevPage: '上一页',
      nextPage: '下一页'
    },
    profile: {
      title: '会员信息',
      pageDesc: '查看您的账户详细信息',
      userId: '用户ID',
      balance: '账户余额',
      registerTime: '注册时间',
      lastLogin: '最后登录',
      accountStatus: '账户状态',
      langSetting: '语言设置',
      statusActive: '正常',
      statusInactive: '已禁用',
      apiInfo: 'API 信息',
      apiKey: 'API 密钥',
      notGenerated: '未生成',
      copy: '复制',
      usageStats: '使用统计',
      smsOrders: '短信订单',
      rechargeCount: '充值次数',
      totalSpent: '总消费',
      chatSessions: '客服会话'
    },
    settings: {
      title: '会员设置',
      pageDesc: '管理您的账户信息和安全设置',
      changePassword: '修改密码',
      currentPassword: '当前密码',
      currentPasswordPh: '请输入当前密码',
      newPassword: '新密码',
      newPasswordPh: '请输入新密码（至少6位）',
      confirmNewPassword: '确认新密码',
      confirmNewPasswordPh: '请再次输入新密码',
      saving: '保存中...',
      saveChanges: '保存修改',
      changeEmail: '修改邮箱',
      currentEmail: '当前邮箱',
      newEmail: '新邮箱',
      newEmailPh: '请输入新邮箱',
      accountSecurity: '账户安全',
      apiKey: 'API密钥',
      notGenerated: '未生成'
    },
	chatSettings: {
      title: '客服设置',
      avatar: '客服头像',
      avatarTip: '建议尺寸 200x200，支持 JPG/PNG，最大 5MB',
      channelName: '客服名称',
      channelNamePlaceholder: '请输入客服显示名称',
      welcomeMsg: '默认欢迎语',
      welcomeMsgPlaceholder: '访客进入聊天时自动发送的欢迎消息',
      save: '保存设置',
      saving: '保存中...',
      saveSuccess: '保存成功',
      saveFailed: '保存失败'
    },
    chatPlan: {
      title: '套餐管理',
      currentPlan: '当前套餐',
      perMonth: '/月',
      seats: '坐席数量',
      seatsUnit: '个',
      maxSessions: '会话上限',
      expiryTime: '到期时间',
      daysLeft: '（剩余 {0} 天）',
      autoRenew: '自动续费',
      btnRenew: '立即续费',
      btnUpgrade: '升级套餐',
      plansTitle: '套餐方案',
      recommended: '推荐',
      current: '当前',
      selectPlan: '选择此方案',
      renewalTitle: '续费记录',
      thOrderId: '订单号',
      thPlan: '套餐',
      thAmount: '金额',
      thPayment: '支付方式',
      thDuration: '续费时长',
      thExpiry: '到期时间',
      thStatus: '状态',
      renewModalTitle: '续费套餐',
      month: '{0} 个月',
      discount10: '9折',
      discount7: '7折',
      confirmRenew: '确认续费',
      renewSuccess: '续费成功！延长 {0} 个月',
	  kaiqiok: '开启成功',
	  guanbiok: '关闭成功',
      renewFailed: '续费失败',
      retryLater: '请重试',
      switchSuccess: '已切换到 {0} 方案',
      switchFailed: '切换失败'
    },
    chatManage: {
      sessionList: '会话列表',
      sessionCount: '{0} 个会话',
      searchVisitor: '搜索访客...',
      online: '在线',
      offline: '离线',
      source: '来源:',
      btnTransfer: '转接',
      btnEndSession: '结束会话',
      btnEnd: '结束',
      inputPlaceholder: '输入消息...',
      send: '发送',
      me: '我',
      selectSession: '请选择一个会话开始聊天',
      emoji: '表情',
      file: '文件',
      myChannel: '我的客服渠道',
      wsOnline: 'WSS 已连接',
      wsOffline: 'WSS 未连接',
      chatLink: '专属客服链接',
      embedCode: '嵌入代码',
      copy: '复制',
      copied: '已复制到剪贴板',
      noSessions: '暂无会话',
      sendImage: '发送图片',
      recall: '撤回'
    },
    receptionRecords: {
      title: '接待记录',
      allStatus: '全部状态',
      completed: '已结束',
      ongoing: '进行中',
      missed: '未接待',
      searchVisitor: '搜索访客姓名...',
      visitor: '访客',
      source: '来源',
      agent: '接待坐席',
      startTime: '开始时间',
      endTime: '结束时间',
      messages: '消息数',
      satisfaction: '满意度',
      status: '状态',
      action: '操作',
      view: '查看',
      notRated: '未评价',
      totalRecords: '共 {0} 条记录',
      prevPage: '上一页',
      nextPage: '下一页',
      detailTitle: '会话详情',
      visitorEmail: '访客邮箱：',
      sourceLabel: '来源：',
      agentLabel: '坐席：',
      durationLabel: '时长：',
      minute: '分钟'
    },
    agentManage: {
      title: '坐席管理',
      addAgent: '添加坐席',
      agent: '坐席',
      account: '账号',
      status: '状态',
      currentSessions: '接待中',
      lastOnline: '最近上线',
      action: '操作',
      online: '在线',
      offline: '离线',
      enable: '启用',
      disable: '禁用',
      edit: '编辑',
      delete: '删除',
      loading: '加载中...',
      empty: '暂无坐席，点击右上角添加',
      addTitle: '添加坐席',
      editTitle: '编辑坐席',
      nameLabel: '坐席姓名',
      namePlaceholder: '如：客服小张',
      accountLabel: '登录账号',
      accountPlaceholder: '如：kefu1',
      passwordLabel: '登录密码',
      passwordPlaceholder: '至少6位',
      resetPasswordLabel: '重置密码（留空不修改）',
      resetPasswordPlaceholder: '留空则保持原密码',
      statusLabel: '状态',
      cancel: '取消',
      saving: '保存中...',
      save: '保存',
      nameRequired: '请填写坐席姓名',
      passwordMin: '密码至少6位',
      accountRequired: '请填写登录账号',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      opFailed: '操作失败',
      networkError: '网络错误，请稍后重试',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      toggleConfirm: '确定要{0}坐席「{1}」吗？',
      deleteConfirm: '确定要删除坐席「{0}」吗？删除后不可恢复！'
    }
  },
  help: {
    title: '帮助页面',
    subtitle: '在这里你可以找到关于如何使用SMS-Man服务的说明和最常见的问题的答案',
    popularQuestions: '热门问题',
    q1: '注册后等待短信的时间要多久？',
    q1a: '短信的等待时间不超过5分钟。如果你在5分钟内没有收到短信，请取消你的号码并购买另一个号码。',
    q2: '我可以接收多少条短信？',
    q3: '最低充值金额是多少？',
    q4: '如果我需要的服务不在列表中，是否可以收到短信？',
    q5: '短信没有收到，我应该怎么做？',
    q6: '"服务暂时不可用"的错误消息是什么意思？',
    q7: '在哪里可以查看我的API key？',
    q8: '你怎么能和我们一起赚钱？',
    serviceGuide: '服务使用须知',
    serviceGuideTitle: '我如何在网上注册？',
    serviceGuideDesc: '注册账号，输入电话号码，选择国家，选择服务，点击购买，然后等待短信。',
    howToRent: '如何为我的服务租用？',
    howToRentDesc: '选择服务，选择国家，选择租期，点击租用。',
    howToBuy: '如何购买一次性短信？',
    howToBuyDesc: '选择服务，选择国家，点击购买短信。',
    howToUseNumber: '怎么使用我租来的号码？',
    howToUseNumberDesc: '在订单页面复制号码，在目标网站输入号码，等待短信。',
    footer: {
      smsPlatform: '接码平台',
      rentNumber: '租用号码',
      apiConnection: 'API连接',
      referral: '返利推广',
      partnership: '合作',
      partners: '合作伙伴',
      blog: '项目分享',
      help: '帮助',
      privacyPolicy: '隐私政策',
      termsOfUse: '使用条款',
      paymentRefund: '付款与退款',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  blog: {
    title: '文章中心',
    recentPosts: '最新文章',
    archives: '归档',
    readMore: '阅读更多',
    comments: '浏览',
    category: '分类',
    currentCategory: '当前分类：',
    clearFilter: '✕ 清除筛选',
    allCategories: '全部分类',
    articleCategories: '文章分类'
  },
  articleDetail: {
    loading: '加载中...',
    notFound: '文章不存在',
    backToList: '← 返回文章列表',
    home: '首页',
    blog: '项目分享',
    views: '次浏览',
    share: '分享：',
    relatedArticles: '相关文章'
  },
  homeApi: {
    title: '对于开发者',
    subtitle: '这一部分是API文档，用于将您的服务与SMS-Man和自动购买号码连接起来。',
    legacyApi: '兼容的API',
    apiV2: 'API 2.0',
    miniApi: '轻量API',
    apiDesc: 'API接口允许你自动购买和接收SMS-Man的短信。服务之间自动同步。为了使你的系统能自动接收、重置API。要使用API，你还需要你的API密钥。你可以通过进入个人资料页面来查看。我们的所有API请求都通过GET或POST方法。所有的请求必须包含token参数和API密钥。',
    getBalance: '查询余额信息',
    getBalanceDesc: '获取当前账户余额',
    params: '参数',
    field: '字段',
    type: '类型',
    required: '需要',
    value: '值值',
    result: '结果',
    possibleErrors: '可能的错误',
    rateLimit: '速率限制',
    getNumber: '请求号码',
    getNumberDesc: '获取指定国家的一个号码，请提供 country_id',
    getSms: '获取短信',
    getSmsDesc: '获取指定订单的短信',
    setStatus: '更改请求状态',
    setStatusDesc: '更改订单状态',
    getCountries: '获取所有国家的列表',
    getCountriesDesc: '获取所有可用国家',
    getServices: '获取所有服务的列表',
    getServicesDesc: '获取所有可用服务'
  },
  onlineSms: {
    hero: {
      title: '在线短信接码平台',
      desc: '在社交网络、网上商城、交易所和在线服务中注册不会收到垃圾邮件或泄露个人数据。',
      viewNumbers: '查看号码',
      receiveCode: '接码'
    },
    countries: {
      title: '选择国家/地区',
      subtitle: '从200+个国家中选择，获取虚拟号码接收短信',
      services: '个服务',
      select: '选择'
    },
    services: {
      title: '今天最受欢迎的服务',
      buy: '购买'
    },
    howItWorks: {
      title: '3步即刻在线租用虚拟号码',
      subtitle: '看看这是如何操作的',
      step1Title: '选择国家',
      step1Desc: '从200+个国家中选择你需要的号码归属地',
      step2Title: '选择服务',
      step2Desc: '选择你需要接收短信的应用或服务',
      step3Title: '接收短信',
      step3Desc: '获取虚拟号码，在线接收验证码短信'
    },
    features: {
      fastTitle: '快速接码',
      fastDesc: '秒级获取验证码，无需等待',
      safeTitle: '隐私保护',
      safeDesc: '使用虚拟号码，保护个人隐私',
      globalTitle: '全球覆盖',
      globalDesc: '支持200+个国家的服务'
    },
    cta: {
      title: '立即注册，开始接码',
      desc: '注册即可获得免费额度，体验便捷的虚拟号码服务',
      register: '免费注册'
    },
    faq: {
      title: '常见问题',
      q1: '什么是在线短信接码？',
      a1: '在线短信接码是通过虚拟号码接收短信验证码的服务，无需使用真实手机号即可注册各类应用。',
      q2: '号码可以使用多久？',
      a2: '根据选择的服务不同，号码可使用20分钟到30天不等。',
      q3: '如何保证隐私安全？',
      a3: '所有号码均为虚拟号码，使用后即销毁，不会泄露您的真实手机号。'
    }
  },
  esim: {
    hero: {
      title: '在线购买 eSIM',
      desc: '即时获取全球移动数据，通过二维码在几秒内激活您的eSIM，告别高昂的漫游费用。',
      learnMore: '了解更多',
      countries: '国家',
      network: '网络',
      activation: '激活'
    },
    howItWorks: {
      title: '三步轻松连接',
      step1Title: '选择套餐',
      step1Desc: '选择您需要的国家/地区和数据套餐',
      step2Title: '支付并获取二维码',
      step2Desc: '完成支付后，您将收到eSIM激活二维码',
      step3Title: '扫码激活',
      step3Desc: '在手机设置中扫描二维码，即可激活eSIM'
    },
    whyEsim: {
      title: '为什么选择eSIM',
      subtitle: '更智能的海外连接方式',
      f1Title: '无漫游费用',
      f1Desc: '使用当地移动网络，避免高昂的国际漫游费',
      f2Title: '即时激活',
      f2Desc: '扫描二维码即可激活，无需等待实体SIM卡',
      f3Title: '保留主号',
      f3Desc: '继续使用您的主号码，同时使用eSIM上网'
    },
    cta: {
      title: '准备好无漫游费旅行了吗？',
      desc: '几分钟内激活eSIM，全球连接无忧'
    },
    comparison: {
      title: 'eSIM vs 本地SIM卡',
      r1: '出行前设置',
      r2: '即时激活',
      r3: '无需换卡',
      r4: '保留主号码',
      r5: '固定可预测价格',
      r6: '仅邮箱注册',
      r7: '支持加密货币'
    },
    plus: {
      title: 'eSIM，加上SMS-MAN已有的所有功能',
      desc: '将您的数据与虚拟号码和短信验证结合——全部在一个账户下'
    },
    faq: {
      title: 'eSIM常见问题',
      q1: '什么是eSIM，它是如何工作的？',
      a1: 'eSIM是嵌入式SIM卡，无需实体卡即可激活移动数据。通过扫描二维码即可激活。',
      q2: '哪些设备支持SMS-MAN eSIM？',
      a2: '大多数现代智能手机都支持eSIM，包括iPhone XS及以上版本、Samsung Galaxy S20及以上等。',
      q3: '激活需要多长时间？',
      a3: '通常只需几秒钟，扫描二维码后即可立即使用。',
      q4: 'eSIM会替换我的主号码吗？',
      a4: '不会，eSIM仅用于数据连接，您的主号码保持不变。',
      q5: '之后可以充值或购买更多数据吗？',
      a5: '可以，您可以随时在账户中购买额外的数据包。'
    }
  },
  agent: {
    hero: {
      title: '成为SMS-MAN代理',
      desc: '通过推广SMS-MAN服务赚取佣金，建立您的被动收入来源。',
      becomeAgent: '成为代理',
      learnMore: '了解更多'
    },
    benefits: {
      title: '代理优势',
      subtitle: '为什么选择成为SMS-MAN代理',
      b1Title: '高额佣金',
      b1Desc: '最高可获得20%的推广佣金',
      b2Title: '被动收入',
      b2Desc: '客户持续消费，您持续获得佣金',
      b3Title: '专属支持',
      b3Desc: '代理专属客户经理，快速解决问题',
      b4Title: '全球市场',
      b4Desc: '面向全球用户推广，无地域限制'
    },
    howItWorks: {
      title: '如何开始',
      step1Title: '注册账户',
      step1Desc: '创建SMS-MAN账户并申请成为代理',
      step2Title: '获取推广链接',
      step2Desc: '获得专属推广链接和营销素材',
      step3Title: '赚取佣金',
      step3Desc: '用户通过您的链接注册消费，您获得佣金'
    },
    commission: {
      title: '佣金等级',
      l1Name: '初级代理',
      l1Desc: '月推广用户1-50人',
      l2Name: '中级代理',
      l2Desc: '月推广用户51-200人',
      l3Name: '高级代理',
      l3Desc: '月推广用户200人以上'
    },
    features: {
      title: '代理工具',
      f1Title: '数据看板',
      f1Desc: '实时查看推广数据和佣金收入',
      f2Title: '推广链接',
      f2Desc: '专属推广链接，精准追踪转化',
      f3Title: '快速提现',
      f3Desc: '佣金可随时提现到多种支付方式',
      f4Title: '专属客服',
      f4Desc: '代理专属客服通道，优先处理问题'
    },
    cta: {
      title: '准备好开始了吗？',
      desc: '立即注册成为SMS-MAN代理，开启您的被动收入之旅',
      joinNow: '立即加入'
    }
  },
  softwareDev: {
    heroTitle: '专业软件开发服务',
    heroDesc: '从需求分析到交付上线，提供全栈定制开发解决方案。涵盖Web应用、移动应用、管理系统、API接口开发等。',
    btnViewCases: '查看案例',
    btnContact: '联系我们',
    servicesTitle: '服务范围',
    servicesSubtitle: '提供全方位的软件开发服务，满足不同业务需求',
    service1Title: 'Web 应用开发',
    service1Desc: '企业官网、电商平台、SaaS系统、管理后台等前后端全栈开发',
    service2Title: '移动应用开发',
    service2Desc: 'iOS/Android原生应用、React Native/Flutter跨平台应用开发',
    service3Title: 'API 接口开发',
    service3Desc: 'RESTful API、WebSocket实时通信、第三方系统对接集成',
    service4Title: '自动化系统',
    service4Desc: '数据采集、自动化脚本、定时任务、业务流程自动化',
    service5Title: '游戏/娱乐系统',
    service5Desc: '棋牌游戏、彩票系统、即时通讯、实时互动平台开发',
    service6Title: '云服务部署',
    service6Desc: '服务器部署、CI/CD流水线、Docker容器化、性能优化',
    techStackTitle: '技术栈',
    casesTitle: '项目案例',
    casesSubtitle: '部分已交付项目展示',
    projectShare: '项目分享',
    processTitle: '开发流程',
    process1Title: '需求沟通',
    process1Desc: '深入了解项目需求，明确功能范围和技术方案',
    process2Title: '方案设计',
    process2Desc: '输出详细的技术架构设计、数据库设计和UI原型',
    process3Title: '开发实现',
    process3Desc: '敏捷开发，定期交付可演示版本，及时沟通进度',
    process4Title: '测试优化',
    process4Desc: '全面的功能测试、性能测试和安全测试',
    process5Title: '部署上线',
    process5Desc: '服务器部署、域名配置、SSL证书、监控告警',
    process6Title: '维护支持',
    process6Desc: '持续的技术支持和bug修复，保障系统稳定运行',
    stats1Label: '交付项目',
    stats2Label: '合作客户',
    stats3Label: '年经验',
    stats4Label: '客户满意度',
    contactTitle: '有项目需求？',
    contactDesc: '告诉我们您的想法，我们将为您提供专业的开发方案和报价',
    contactOnline: '在线客服',
    contactBtn: '立即咨询'
  },
  lotteryPage: {
    heroTitle: '实时开奖中心',
    heroDesc: '多彩种即时开奖，数据实时同步，公平公正公开',
    statLottery: '彩种',
    statNonStop: '不间断开奖',
    statSync: '数据同步',
    periodDraw: '第 {0} 期开奖',
    currentRemain: '当前{0}期，剩余{1}期',
    dragonTiger: '1-5龙虎',
    championSum: '冠亚和',
    betNow: '立即投注',
    tabHistory: '历史开奖',
    tabRoad: '路珠分析',
    tabHotCold: '冷热分析',
    tabTrend: '冠亚和走势',
    rulesTitle: '玩法规则',
    rule1Title: '龙虎玩法',
    rule1Desc: '根据开奖号码的前后位置比较大小，前大为龙，后大为虎。',
    rule2Title: '冠亚和玩法',
    rule2Desc: '冠军和亚军号码相加，根据总和判断大小单双。',
    rule3Title: '大小单双',
    rule3Desc: '根据指定位置号码或总和判断大小（1-5为小，6-10为大）和单双。',
    rule4Title: '路珠分析',
    rule4Desc: '通过历史开奖数据的路珠图，分析开奖规律和趋势。',
    dragon: '龙',
    tiger: '虎',
    big: '大',
    small: '小',
    odd: '单',
    even: '双',
    countdownMin: '分',
    countdownSec: '秒',
    nameSpeedRacing: '极速赛车',
    nameSgAirship: 'SG飞艇',
    nameSpeedAirship: '极速飞艇',
    nameLuckyAirship: '幸运飞艇',
    logoRacing: '赛车',
    logoAirship: '飞艇'
  },
  apiDocs: {
    pageTitle: 'API 接口文档',
    pageSubtitle: '提供短信接码、彩票开奖、客服系统等多种API接口，助力快速集成',
    tabSms: '短信接码 API',
    tabLottery: '彩票开奖 API',
    tabChat: '客服对接 API',
    versionLegacy: '兼容的 API',
    versionV2: 'API 2.0',
    versionMini: '轻量API',
    baseAddress: '基础地址',
    requestMethod: '请求方式',
    returnFormat: '返回格式',
    authMethod: '认证方式',
    requestParams: '请求参数',
    field: '字段',
    type: '类型',
    required: '必填',
    description: '说明',
    yes: '是',
    no: '否',
    returnExample: '返回示例',
    smsDesc: '短信接码API提供虚拟号码获取、短信接收、状态管理等完整功能，支持200+国家的服务。',
    lotteryDesc: '彩票开奖API提供实时开奖数据查询、历史开奖记录、走势分析等接口，支持多种彩种。',
    chatDesc: '客服系统API提供会话管理、消息收发、坐席管理等功能，支持WebSocket实时通信和RESTful接口。',
    ep: {
      getBalance: '获取余额', getNumber: '获取号码', getSms: '获取短信',
      checkBalance: '查询余额', createOrder: '创建订单', querySms: '查询短信',
      setStatus: '设置状态', getCountries: '获取国家列表', getServices: '获取服务列表',
      getLotteryList: '获取开奖列表', getLotteryHistory: '获取历史开奖',
      getLotteryTypes: '获取彩种列表', liveDraw: '实时开奖',
      lotteryHistory: '历史开奖', lotteryStats: '开奖统计',
      latestDraw: '最新开奖', createSession: '创建会话',
      sendMessage: '发送消息', getMessageHistory: '获取消息历史',
      agentStatus: '坐席状态', closeSession: '关闭会话', quickSend: '快速发消息'
    },
    epd: {
      getBalance: '查询当前账户余额', getNumber: '获取一个虚拟号码用于接收短信',
      getSms: '获取指定号码的短信验证码', checkBalance: '获取当前账户可用余额',
      createOrder: '创建接码订单，获取虚拟号码', querySms: '轮询获取订单的短信内容',
      setStatus: '设置订单状态（已收到/取消/继续使用）',
      getCountries: '获取所有支持的国家列表', getServices: '获取所有支持的短信服务',
      getLotteryList: '获取当前所有彩种的最新开奖信息', getLotteryHistory: '获取指定彩种的历史开奖记录',
      getLotteryTypes: '获取所有支持的彩种信息', liveDraw: '获取指定彩种的最新开奖结果',
      lotteryHistory: '获取历史开奖记录，支持分页', lotteryStats: '获取开奖数据统计（冷热号、遗漏值等）',
      latestDraw: '获取所有彩种最新开奖（最简接口）', createSession: '创建一个新的客服会话',
      sendMessage: '向会话中发送一条消息', getMessageHistory: '获取会话的聊天记录',
      agentStatus: '获取在线客服坐席列表和状态', closeSession: '结束指定会话',
      quickSend: '一键创建会话并发送消息',
      getNumberSimple: '一键获取号码（最简接口）', getSmsSimple: '获取短信内容',
      createSessionV2: '创建客服会话，自动分配坐席', sendMessageV2: '向指定会话发送消息'
    }
  },
  liveChat: {
    heroTitle: '在线客服系统',
    heroDesc: '基于 WebSocket 的实时客服聊天平台，支持多坐席协作、智能分配、消息历史、文件传输，为您的客户提供7×24小时即时服务。',
    btnFreeTrial: '免费试用',
	catedengl: '客服登录',
    btnDemo: '电脑客户端下载',
    previewName: '客服小王',
    previewStatus: '● 在线',
    previewMsg1: '您好！请问有什么可以帮您？',
    previewMsg2: '我想了解一下你们的服务',
    previewMsg3: '好的，我来为您详细介绍...',
    inputPlaceholder: '输入消息...',
    featuresTitle: '核心功能',
    featuresSubtitle: '全方位的客服解决方案，提升客户满意度',
    feature1Title: '实时消息',
    feature1Desc: '基于 WebSocket 的毫秒级消息推送，确保对话流畅无延迟',
    feature2Title: '多坐席协作',
    feature2Desc: '支持多个客服同时在线，智能分配会话，团队协作更高效',
    feature3Title: '消息历史',
    feature3Desc: '完整的聊天记录保存，支持搜索和导出，方便追溯和培训',
    feature4Title: '文件传输',
    feature4Desc: '支持图片、文档等多种文件类型的发送和接收',
    feature5Title: '智能分配',
    feature5Desc: '根据客服负载、技能标签自动分配客户，提升响应效率',
    feature6Title: '数据报表',
    feature6Desc: '实时统计会话量、响应时间、满意度等关键指标',
    stepsTitle: '快速接入',
    step1Title: '注册账户',
    step1Desc: '创建管理员账户，配置企业信息和客服团队',
    step2Title: '嵌入代码',
    step2Desc: '将一行代码嵌入您的网站，即可显示客服聊天窗口',
    step3Title: '开始服务',
    step3Desc: '客服登录后台，即可接收和回复客户消息',
    dashboardTitle: '强大的管理后台',
    dashboardDesc: '实时监控客服状态、会话数据、客户满意度，让管理更高效',
    dashFeature1: '实时查看在线客服状态和会话数量',
    dashFeature2: '会话分配规则和自动分配策略',
    dashFeature3: '客服工作时长和绩效统计',
    dashFeature4: '客户满意度评分和反馈收集',
    dashFeature5: '聊天记录搜索和导出功能',
    dashFeature6: '自定义快捷回复和知识库',
    dashStat1: '今日会话',
    dashStat2: '满意度',
    dashStat3: '平均响应',
    dashStat4: '在线坐席',
    pricingTitle: '方案价格',
    pricingBadge: '推荐',
    pricingPeriod: '/月',
    btnSelectPlan: '选择方案',
    planBasic: '基础版',
    planPro: '专业版',
    planEnterprise: '企业版',
    ctaTitle: '准备好提升客服体验了吗？',
    ctaDesc: '立即注册，免费试用全部功能',
    ctaBtn: '免费开始使用',
    pf1Basic: '1个坐席', pf2Realtime: '实时聊天', pf3History: '消息历史',
    pf4Reports: '基础报表', pf5Email: '邮件支持',
    pf1Agents: '10个坐席', pf4AdvReports: '高级报表', pf5Smart: '智能分配',
    pf6File: '文件传输', pf7Priority: '优先支持',
    ef1Unlimited: '无限坐席', ef2All: '全部功能', ef3Api: 'API接口',
    ef4Private: '私有部署', ef5Dedicated: '专属客服', ef6Sla: 'SLA保障'
  },
  apiMsg: {
    userNotFound: '该邮箱尚未注册', wrongPassword: '密码错误', accountDisabled: '账号已被禁用',
    agentNotFound: '坐席账号不存在', agentDisabled: '坐席账号已被禁用',
    notLogin: '请先登录', tokenExpired: '登录已过期，请重新登录',
    emailRequired: '请输入邮箱', emailInvalid: '邮箱格式不正确',
    emailPasswordRequired: '邮箱和密码不能为空', accountPasswordRequired: '账号和密码不能为空',
    agentAccountRequired: '坐席账号和密码不能为空',
    passwordMin: '密码至少 6 位', newPasswordMin: '新密码至少 6 位',
    emailExists: '该邮箱已被注册', usernameExists: '该用户名已被占用',
    captchaWrong: '验证码错误', captchaExpired: '验证码已过期，请重新获取',
    paramError: '参数错误', paramIncomplete: '请填写完整信息', missingId: '缺少 ID',
    nothingToUpdate: '没有需要更新的内容', invalidStatus: '状态值无效', indexOutOfRange: '索引超出范围',
    missingChannelCode: '缺少渠道码', channelNotFound: '渠道不存在', channelClosed: '该渠道已关闭',
    noChatChannel: '该会员暂未开通客服渠道', chatPlanExpired: '客服套餐已过期，暂时无法使用',
    noAgentOnlineRetry: '当前暂无坐席在线，请稍后再试',
    targetAgentInvalid: '目标坐席不存在或未启用', agentNoOperate: '坐席不存在或无权操作',
    sessionNotFound: '会话不存在', sessionMismatch: '会话不匹配',
    noPermissionTransfer: '无权转接该会话', noPermissionClose: '无权结束该会话',
    noPermissionDelete: '无权删除该会话',
    chatHasHistory: '该会话有聊天记录，无法删除', clientOnline: '客户在线，无法删除',
    onlyAgentRecall: '只能撤回客服消息',
    balanceInsufficient: '余额不足', rechargeMinAmount: '充值金额至少 1 美元',
    orderNotFound: '订单不存在', orderCancelled: '该订单已取消', orderConfirmed: '该订单已确认到账',
    orderNotPayable: '该订单当前状态不支持此操作',
    planNotFound: '套餐不存在', serviceNotFound: '服务不存在', articleNotFound: '文章不存在',
    numberUnavailable: '号码不可用', noAvailableNumber: '暂无可用号码',
    numberExists: '号码已存在', rentalNotFound: '租用记录不存在',
    agentLimitReached: '已达套餐坐席数上限', emailSendFailed: '邮件发送失败，请稍后重试'
  },
  clientDownload: {
    badge: '官方桌面客户端',
    heroTitle: '客服客户端下载',
    heroDesc: '专为客服坐席打造的桌面客户端，支持多会话同时接待、实时消息推送、快捷回复与坐席转接，让您的客服团队高效处理每一位客户。',
    winDownload: 'Windows 版下载',
    winHint: 'Windows 10 / 11',
    macDownload: 'macOS 版下载',
    macHint: 'macOS 10.15 及以上',
    previewAlt: '客服客户端界面预览',
    notice: '下载后解压即可运行，无需安装。如系统提示“未知开发者”，请在系统设置中允许运行。',
    featuresTitle: '客户端核心功能',
    featuresSubtitle: '为高频接待场景设计的桌面工具，比网页版更稳定、更高效',
    f1Title: '多会话管理',
    f1Desc: '左侧会话列表实时更新，未读消息高亮提醒，多个客户同时接待也不会遗漏。',
    f2Title: '实时消息推送',
    f2Desc: '基于 WebSocket 长连接，访客消息毫秒级送达，断线自动重连。',
    f3Title: '快捷回复',
    f3Desc: '常用话术一键发送，减少重复输入，显著提升响应速度。',
    f4Title: '转接与协作',
    f4Desc: '支持将会话转接给其他坐席，团队协作处理复杂问题。',
    stepsTitle: '三步开始使用',
    s1Title: '下载并解压',
    s1Desc: '根据您的系统选择 Windows 或 macOS 版本，下载后解压即可运行。',
    s2Title: '登录坐席账号',
    s2Desc: '使用会员中心创建的客服账号登录，自动同步所属渠道的会话。',
    s3Title: '开始接待客户',
    s3Desc: '访客消息实时推送，配合快捷回复与转接功能高效服务客户。',
    ctaTitle: '还没有客服账号？',
    ctaDesc: '前往会员中心创建坐席账号，立即开始接待客户。',
    ctaBtn: '前往会员中心'
  },
  visitorChat: {
    noAgentOnline: '当前暂无坐席在线，您发送的消息将在坐席上线后收到回复',
    online: '在线',
    offline: '离线',
    connecting: '连接中...',
    defaultTitle: '在线客服',
    defaultWelcome: '您好！欢迎使用在线客服系统。请问有什么可以帮您？',
    channelNotFound: '渠道不存在或已关闭',
    loadError: '加载失败，请稍后重试',
    imageTooLarge: '图片大小不能超过 2MB',
    sendImage: '发送图片',
    inputPlaceholder: '输入消息...',
    supportSuffix: '的客服'
  }
}
